export default __webpack_public_path__ + "static/media/icon-security.1c819fa1.png";